import { pinia } from './store'
import { createStorePersistence } from './utils/storePersistence'
import { useLocalStore } from './stores/local'

const localPiniaStore = useLocalStore(pinia)

// Guard localStorage access and only initialize persistence if storage is available
if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
  try {
    // If we get here, localStorage is available
    createStorePersistence({ storage: localStorage, key: 'wsd-pinia', store: localPiniaStore })
  } catch (e) {
    console.warn('localStorage is not available, store persistence disabled:', e)
  }
}

export default {
  get state () {
    return localPiniaStore.$state
  },
  get getters () {
    return new Proxy({}, {
      get (_, key) {
        return localPiniaStore[key]
      }
    })
  },
  commit (type, payload) {
    return localPiniaStore[type](payload)
  }
}
